import getView from '@/helpers/components/getView';

export default [
  {
    path: '/',
    redirect: {
      name: 'Login',
    },
  },
  {
    path: '/Login',
    name: 'Login',
    component: getView('account/Login'),
    meta: { allowAnonymous: true, hideNavbar: true },
  },
  {
    path: '/oauth-callback',
    name: 'Callback',
    component: getView('account/Callback'),
    meta: { hideNavbar: true, allowAnonymous: true },
  },
];
